import request from '@/util/request';
import qs from 'qs';
// 社区商家管理
export const getList = (params, options) =>
request.get('/api/v4ward/community/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/update', params,options)
